import React from 'react';
export const ProductCard = ({ available, id, image, link, price, tags, title, variantId, }) => {
    const [badge, badgeColor] = tags.reduce((badgeData, tag) => {
        if (badgeData.length > 0) {
            return badgeData;
        }
        switch (tag) {
            case 'NEW':
                return ['NEW', 'bg-blue-500'];
            case 'SEASONAL':
                return ['SEASONAL', 'bg-green'];
            case 'ONSALE':
                return ['ON SALE', 'bg-red'];
            case 'Bestseller':
                return ['BEST SELLER', 'bg-yellow'];
            default:
                return [];
        }
    }, []);
    let [mainTitle, subTitle] = title.split('-').map(t => t.trim());
    if (typeof mainTitle === 'string' && mainTitle.length > 25) {
        mainTitle = mainTitle.slice(0, 22) + '...';
    }
    if (typeof subTitle === 'string' && subTitle.length > 26) {
        subTitle = subTitle.slice(0, 23) + '...';
    }
    return (React.createElement("div", null,
        React.createElement("a", { href: link },
            React.createElement("div", { className: "flex flex-col mb-2" },
                React.createElement("div", { className: "relative" },
                    badge ? (React.createElement("div", { className: `absolute z-10 right-2 top-2 ${badgeColor} text-white font-bold text-xs text-center px-2 py-2` }, badge)) : undefined,
                    React.createElement("img", { className: "object-cover w-full rounded", loading: "lazy", src: image, alt: title }))),
            React.createElement("div", { className: "h-24" },
                React.createElement("div", { className: "h-5 mb-1 text-sm font-semibold" }, mainTitle),
                React.createElement("div", { className: "h-5 mb-1 text-sm font-medium" }, subTitle),
                React.createElement("div", { className: "h-5 mb-1" },
                    React.createElement("div", { className: "mx-auto flex justify-center", "data-bv-show": "inline_rating", "data-bv-product-id": id, "data-bv-redirect-url": link, "data-bv-seo": "false" })),
                React.createElement("div", { className: "text-xs font-medium" },
                    "$",
                    (Number(price) / 100).toFixed(2))))));
};
